import _ from "lodash";

const NAV_FAVORITE_SPORTS_KEY = "nav-favorite-sports-v20";
const NAV_MAIN_SPORTS_KEY = "nav-main-sports-v20";
const NAV_OTHER_SPORTS_KEY = "nav-other-sports-v20";
const NAV_UNION_SPORTS_KEY = "nav-union-sports-v20";
const NAV_THIRD_ROW_KEY = "nav-third-row-v20";
const NAV_NOTIFICATION_DOT_KEY = "nav-notification-dot-v20";
//Update NAV_ALL_SPORTS_KEY in App.js loadSportsList function

//Delete previous keys
localStorage.removeItem("nav-favorite-sports-v19");
localStorage.removeItem("nav-main-sports-v19");
localStorage.removeItem("nav-other-sports-v19");
localStorage.removeItem("nav-union-sports-v19");
localStorage.removeItem("nav-third-row-v19");
localStorage.removeItem("nav-notification-dot-v19");
localStorage.removeItem("nav-all-sports-v19");

const state = {
	favoriteSports: localStorage.getItem(NAV_FAVORITE_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_FAVORITE_SPORTS_KEY))
		: [],
	mainSports: localStorage.getItem(NAV_MAIN_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_MAIN_SPORTS_KEY))
		: [],
	otherSports: localStorage.getItem(NAV_OTHER_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_OTHER_SPORTS_KEY))
		: [],
	unionSports: localStorage.getItem(NAV_UNION_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_UNION_SPORTS_KEY))
		: [],
	thirdRow: localStorage.getItem(NAV_THIRD_ROW_KEY)
		? JSON.parse(localStorage.getItem(NAV_THIRD_ROW_KEY))
		: [],
	notificationDot: localStorage.getItem(NAV_NOTIFICATION_DOT_KEY)
		? JSON.parse(localStorage.getItem(NAV_NOTIFICATION_DOT_KEY))
		: {
				visited: false,
				visible: false,
		  },
};

const persistNavGroup = (navGroup, key) => {
	localStorage.setItem(key, JSON.stringify(navGroup));
};

const getters = {
	favoriteSports: (state) => {
		return state.favoriteSports ? state.favoriteSports : [];
	},
	mainSports: (state) => {
		return state.mainSports ? state.mainSports : [];
	},
	otherSports: (state) => {
		return state.otherSports ? state.otherSports : [];
	},
	unionSports: (state) => {
		return state.unionSports ? state.unionSports : [];
	},
	thirdRow: (state) => {
		return state.thirdRow ? state.thirdRow : [];
	},
	notificationDot: (state) => {
		return state.notificationDot
			? state.notificationDot
			: {
					visited: false,
					visible: false,
			  };
	},
};

const actions = {
	updateUnionSports({ commit }) {
		const unionSports = _.union(
			state.mainSports,
			state.otherSports,
			state.thirdRow
		);
		commit("setUnionSports", unionSports);
	},
	updateNotificationDotVisible({ commit, state }, visible) {
		let notificationDotState = state.notificationDot;
		notificationDotState.visible = visible;
		commit("setNotificationDot", notificationDotState);
	},
	updateNotificationDotVisited({ commit, state }, visited) {
		let notificationDotState = state.notificationDot;
		notificationDotState.visited = visited;
		commit("setNotificationDot", notificationDotState);
	},
};

const mutations = {
	setFavoriteSports(state, sports) {
		state.favoriteSports = sports;
		persistNavGroup(state.favoriteSports, NAV_FAVORITE_SPORTS_KEY);
	},
	setMainSports(state, sports) {
		state.mainSports = sports;
		persistNavGroup(state.mainSports, NAV_MAIN_SPORTS_KEY);
	},
	setOtherSports(state, sports) {
		state.otherSports = sports;
		persistNavGroup(state.otherSports, NAV_OTHER_SPORTS_KEY);
	},
	setUnionSports(state, sports) {
		state.unionSports = sports;
		persistNavGroup(state.unionSports, NAV_UNION_SPORTS_KEY);
	},
	setThirdRow(state, items) {
		state.thirdRow = items;
		persistNavGroup(state.thirdRow, NAV_THIRD_ROW_KEY);
	},
	setNotificationDot(state, notificationDot) {
		state.notificationDot = notificationDot;
		persistNavGroup(state.notificationDot, NAV_NOTIFICATION_DOT_KEY);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
